import { toStringMap, toTimeout, toHeader } from "../util";
import { parse } from "../error"; // Writes a resource to URL string

var toRetrieveUrl = function toRetrieveUrl(options, id) {
  return [options.client.url(), options.resource, encodeURIComponent(id), options.action].filter(function (e) {
    return e !== undefined;
  }).join("/");
};

export var retrieveMethod = function retrieveMethod(options) {
  var client = options.client;
  return function (id, request) {
    return client.config.agent.http({
      method: "GET",
      url: toRetrieveUrl(options, id),
      query: toStringMap(request.query),
      header: toHeader(request, client),
      timeout: toTimeout(request, client)
    }).then(function (response) {
      var error = parse(response);
      if (error) throw error;
      return response;
    });
  };
};
export var listMethod = function listMethod(options) {
  var client = options.client,
      resource = options.resource;
  return function (request) {
    return client.config.agent.http({
      method: "GET",
      url: "".concat(client.url(), "/").concat(resource),
      query: toStringMap(request.query),
      header: toHeader(request, client),
      timeout: toTimeout(request, client)
    }).then(function (response) {
      var error = parse(response);
      if (error) throw error;
      return response;
    });
  };
};